export default __webpack_public_path__ + "7532254da5a048aaf947f7adb4bb08ba.png";